import React, { useState, useEffect } from 'react';
import SessionTimeoutModal from './SessionTimeoutModal';
import sessionNetworkManager from '../services/SessionNetworkManager';

const SessionManager: React.FC = () => {
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);

  useEffect(() => {
    // Listen for session timeout - only show modal for critical failures
    const handleSessionTimeout = (data: any) => {
      console.log('🕐 Session timeout detected:', data.message);
      setShowTimeoutModal(true);
    };

    // Listen for auth expiry (token refresh failed) - critical failure
    const handleAuthExpired = (data: any) => {
      console.log('🔐 Auth expired:', data.message);
      setShowTimeoutModal(true);
    };

    // Silent handling of other events - just log them
    const handleAuthRefreshStart = () => {
      console.log('🔄 Token refresh started (silent)');
    };

    const handleAuthRefreshSuccess = () => {
      console.log('✅ Token refresh successful (silent)');
    };

    const handleAuthRefreshFailed = (data: any) => {
      console.log('❌ Token refresh failed (silent):', data.error);
      // Only show modal if it's a critical failure (not just a network hiccup)
    };

    // Register event listeners
    sessionNetworkManager.on('session:timeout', handleSessionTimeout);
    sessionNetworkManager.on('auth:expired', handleAuthExpired);
    sessionNetworkManager.on('auth:refresh-start', handleAuthRefreshStart);
    sessionNetworkManager.on('auth:refresh-success', handleAuthRefreshSuccess);
    sessionNetworkManager.on('auth:refresh-failed', handleAuthRefreshFailed);

    // Cleanup
    return () => {
      sessionNetworkManager.off('session:timeout', handleSessionTimeout);
      sessionNetworkManager.off('auth:expired', handleAuthExpired);
      sessionNetworkManager.off('auth:refresh-start', handleAuthRefreshStart);
      sessionNetworkManager.off('auth:refresh-success', handleAuthRefreshSuccess);
      sessionNetworkManager.off('auth:refresh-failed', handleAuthRefreshFailed);
    };
  }, []);

  return (
    <>
      {/* Session Timeout Modal - blocks entire screen */}
      <SessionTimeoutModal 
        isOpen={showTimeoutModal}
        onLoginRedirect={() => {
          console.log('🔐 User clicked login redirect');
          setShowTimeoutModal(false);
          // Modal will handle the actual redirect
        }}
      />
    </>
  );
};

export default SessionManager;
